/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines a utlity to return Device Symbol based on the CIMSymbol feature
 * 
 *   import {createCircleSymbol} from '@ion/dls/src/maps/symbols/CircleSymbol';
 * 
 *   const renderer = {
 *     type : 'CIMPointSymbol',
 *     symbolLayers: [
 *       createCircleSymbol()
 *     ]
 *    }; 
 */

export const createCircleSymbol = (size: number = 15, color: number[] = [129, 222, 242]) => {
  return {
    type               : 'CIMVectorMarker',
    enable             : true,
    anchorPoint        : {x: 0, y: 0},
    anchorPointUnits   : 'Relative',
    dominantSizeAxis3D : 'Y',
    size,
    billboardMode3D    : 'FaceNearPlane',
    frame              : {xmin: 0, ymin: 0, xmax: 17, ymax: 17},
    markerGraphics     : [
      {
        type     : 'CIMMarkerGraphic',
        geometry : {
          rings : [
            [
              [8.5, 0],
              [7.02, 0.13],
              [5.59, 0.51],
              [4.25, 1.14],
              [3.04, 1.99],
              [1.99, 3.04],
              [1.14, 4.25],
              [0.51, 5.59],
              [0.13, 7.02],
              [0, 8.5],
              [0.13, 9.98],
              [0.51, 11.41],
              [1.14, 12.75],
              [1.99, 13.96],
              [3.04, 15.01],
              [4.25, 15.86],
              [5.59, 16.49],
              [7.02, 16.87],
              [8.5, 17],
              [9.98, 16.87],
              [11.41, 16.49],
              [12.75, 15.86],
              [13.96, 15.01],
              [15.01, 13.96],
              [15.86, 12.75],
              [16.49, 11.41],
              [16.87, 9.98],
              [17, 8.5],
              [16.87, 7.02],
              [16.49, 5.59],
              [15.86, 4.25],
              [15.01, 3.04],
              [13.96, 1.99],
              [12.75, 1.14],
              [11.41, 0.51],
              [9.98, 0.13],
              [8.5, 0]
            ]
          ]
        },
        symbol : {
          type         : 'CIMPolygonSymbol',
          symbolLayers : [
            {
              type        : 'CIMSolidStroke',
              enable      : true,
              capStyle    : 'Round',
              joinStyle   : 'Round',
              lineStyle3D : 'Strip',
              miterLimit  : 10,
              width       : 0.7,
              color       : [255, 255, 255, 255],
              colorLocked : false
            },
            {
              type        : 'CIMSolidFill',
              enable      : true,
              color       : [...color, 255],
              colorLocked : false
            }
          ]
        }
      }
    ],
    scaleSymbolsProportionally : true,
    respectFrame               : true,
    rotateClockwise            : false,
    colorLocked                : true,
    offsetX                    : 0,
    offsetY                    : 0
  };
};
